import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getTree(id) {
    return api.get(`api/v1/tree-department`);
  },
  change(id, data) {
    return api.put(`api/v1/tree-department/${id}`, data);
  },
  getEmployee(search) {
    return api.get(`api/v1/tree-department/list?search=${search}`);
  },
  deleteEmp(id) {
    return api.delete(`api/v1/tree-department/${id}`);
  },
};
